import PropTypes from 'prop-types'
import React from 'react'
import Base from '../../../containers/BaseContainer'
import { I18n } from 'react-redux-i18n'
import classNames from 'classnames'

import Toggle from '../../Toggle/Toggle'
import styles from './AppBar.module.scss'
// import { objectEquals } from '../../../ApplicationUtils.js'

class AppBar extends Base {

  state = {}

  componentDidMount() {
  }

  _renderLangs(lang, index, props) {
    let langClassName = classNames(styles.lang, props.lang === lang ? styles.activeLang : null)
    return (
      <div
        key={index}
        data-lang={lang}
        data-action='changeLang'
        className={langClassName}
        onClick={props.onChangeLang}>
        {lang}
      </div>
    )
  }

  render() {
    let deleteButtonClassList = classNames(styles.button, styles.delete)
    let saveButtonClassList = classNames(styles.button, styles.save)
    let undoButtonClassList = classNames(styles.button, styles.undo)
    let editButtonClassList = classNames(styles.button, styles.edit)
    let colorsButtonClassList = classNames(styles.button, styles.colors)
    let dupButtonClassList = classNames(styles.button, styles.dup)

    let appBarClassList = classNames(styles.appBar,
      this.props.withMenu ? styles.withMenu : null,
      this.props.className ? styles[this.props.className] : null,
      this.props.hideAppBar === true ? styles.withoutAppBar : null,
      this.props.isAtBottom === true ? styles.bottom : null)

    let titleClassList = classNames(styles.title, this.props.langs.length ? styles.withLangs : null)
    let inputClassList = classNames(styles.input, this.props.langs.length ? styles.withLangs : null)

    let saveBtnTitle = this.props.saveBtTitle ? I18n.t(this.props.saveBtTitle) : I18n.t('Content.save')
    let saveBtnLb = this.props.saveBtLabel ? I18n.t(this.props.saveBtLabel) : I18n.t('AppBar.save')

    return (
      <div className={appBarClassList}>
        {this.props.title ? <div className={titleClassList}>
          {this.props.title}
        </div> : null}
        {this.props.onSearch ? <div className={inputClassList}>
          <input type='text' value={this.props.search} onChange={this.props.onSearch}
            placeholder={I18n.t('Application.searchPlaceholder')} />
        </div> : null}
        <div className={styles.langs}>
          {this.props.langs.map((item, index) => {
            return this._renderLangs(item, index, this.props)
          })}
        </div>
        <div className={styles.actions}>
          {this.props.withColors
            ? <div className={colorsButtonClassList}
              id='editColors'
              data-action='editColors'
              title={I18n.t('Content.configureSectionColors')}
              onClick={this.props.onColorsEditClick}
            />
            : null
          }
          {this.props.onEditClick && (this.props.content ? this.props.content.title || this.props.content.sections
            : true)
            ? <div className={editButtonClassList}
              id='edit'
              data-action='edit'
              title={I18n.t('Content.configureSection')}
              onClick={this.props.onEditClick}></div>
            : null
          }
          {this.props.onSaveClick && (this.props.content
            ? this.props.content.title || this.props.content.contents || this.props.content.sections : true)
            ? <div className={saveButtonClassList}
              data-action='save'
              title={saveBtnTitle}
              onClick={this.props.onSaveClick}>{saveBtnLb}</div>
            : null
          }
          {this.props.withToggle
            ? <Toggle type={'check'} position={0} toggleInitState={this.props.toggleState}
              toggleChanged={this.props.withToggle} /> : null}
          {this.props.onDupClick
            ? <div className={dupButtonClassList}
              data-action='dup'
              title={I18n.t('Content.duplicate')}
              onClick={this.props.onDupClick}></div> : null}
          {this.props.onDeleteClick && (this.props.selectedSection ? this.props.selectedSection >= 0 : true) &&
            (this.props.selectedSection ? this.props.selectedItem < this.props.selectedSectionLength : true)
            ? <div className={deleteButtonClassList}
              data-action='delete'
              title={I18n.t('Content.delete')}
              onClick={this.props.onDeleteClick}></div> : null}
          {this.props.onUndoClick
            ? <div className={undoButtonClassList}
              data-action='undo'
              title={I18n.t('Content.cancel')}
              onClick={this.props.onUndoClick}></div> : null}
        </div>
      </div>
    )
  }

}

AppBar.propTypes = {
  className: PropTypes.string,
  lang: PropTypes.string.isRequired,
  langs: PropTypes.array.isRequired,
  title: PropTypes.string,
  saveBtTitle: PropTypes.string,
  saveBtLabel: PropTypes.string,
  withMenu: PropTypes.bool.isRequired,
  selectedSection: PropTypes.number,
  selectedItem: PropTypes.number,
  content: PropTypes.object,
  reduxContent: PropTypes.object,
  onChangeLang: PropTypes.func,
  onEditClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  onSaveClick: PropTypes.func,
  onUndoClick: PropTypes.func,
  onDupClick: PropTypes.func,
  selectedSectionLength: PropTypes.number,
  hideAppBar: PropTypes.bool,
  withToggle: PropTypes.func,
  toggleState: PropTypes.bool,
  onSearch: PropTypes.func,
  search: PropTypes.string,
  isAtBottom: PropTypes.bool,
}

export default AppBar
